export function GetPublished() {
  return (
    <div className="relative overflow-hidden rounded-[14px] bg-[#9B2C24] px-6 py-[22px] text-[#FDF6EC]">
      <div className="absolute -top-[46px] -right-[46px] h-[170px] w-[170px] rounded-full border border-dashed border-[#FDF6EC]/[.28]" />
      <div className="absolute -top-[18px] -right-[18px] h-[104px] w-[104px] rounded-full border border-dashed border-[#FDF6EC]/20" />
      <div className="relative text-[11px] font-bold tracking-[.16em] text-[#FDF6EC]/90">
        GET PUBLISHED
      </div>
      <div className="relative mt-4 flex items-center gap-3.5">
        <div className="flex h-[76px] w-[76px] flex-none flex-col items-center justify-center rounded-[15px] bg-[#B23A31] shadow-[0_6px_18px_rgba(0,0,0,.25)]">
          <span className="text-[13px] font-extrabold leading-tight tracking-wide text-white">
            UK
          </span>
          <span className="border-b border-white/70 text-[13px] font-extrabold leading-tight tracking-wide text-white">
            INVESTOR
          </span>
          <span className="mt-0.5 text-[6px] font-bold tracking-[.3em] text-white/80">
            MAGAZINE
          </span>
        </div>
        <div className="text-sm font-bold leading-[1.5]">
          High-quality articles have the chance to be published in UK Investor Magazine
        </div>
      </div>
      <div className="relative mt-4 flex items-center gap-2.5">
        <span className="h-px w-[26px] flex-none bg-[#FDF6EC]/50" />
        <span className="font-serif text-[12.5px] italic text-[#FDF6EC]/85">
          selected by the editorial team each cohort
        </span>
      </div>
    </div>
  );
}
